import React, { useState } from 'react';

/**
 * Champ de mot de passe avec oeil d'affichage (bascule password / text).
 *
 * ⚠ L'oeil ne révèle que ce qui est saisi dans le champ — ou ce que le gestionnaire
 * de mots de passe du navigateur y a pré-rempli. Il ne permet PAS de retrouver le mot
 * de passe d'un compte : le serveur ne stocke qu'un hash BCrypt (AdminUser.passwordHash),
 * le clair n'existe nulle part côté serveur.
 *
 * Styles inline comme le reste du frontend (pas de CSS central) ; passer `wrapperStyle`
 * pour les marges externes et `style` pour le champ lui-même, sinon l'oeil se décentre.
 */
export default function PasswordInput({ style, wrapperStyle, ...inputProps }) {
  const [visible, setVisible] = useState(false);
  const legende = visible ? 'Masquer le mot de passe' : 'Afficher le mot de passe';

  return (
    <div style={{ ...styles.wrapper, ...wrapperStyle }}>
      <input
        {...inputProps}
        type={visible ? 'text' : 'password'}
        style={{ ...style, paddingRight: '2.25rem' }}
      />
      <button
        type="button"
        onClick={() => setVisible(!visible)}
        title={legende}
        aria-label={legende}
        aria-pressed={visible}
        style={styles.eye}
      >
        {visible ? '🙈' : '👁'}
      </button>
    </div>
  );
}

const styles = {
  wrapper: { position: 'relative', display: 'block' },
  eye: {
    position: 'absolute',
    right: '0.35rem',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'transparent',
    border: 'none',
    padding: '0.15rem 0.3rem',
    lineHeight: 1,
    fontSize: '1rem',
    cursor: 'pointer',
    color: '#444444',
  },
};
